(function ($) {

	function show_sizes() {
		$('[data-choose-variant]').gp_on('click', function (e) {
			$(this).hide();
			$(this).siblings('.cart-cross-sell-card__optional').show()
		})
	}

	$(document).gp_ready(show_sizes)

})(jQuery);